<template>
<main id="main" class="main" role="main">
    <agile v-if="$store.state.site_data && $store.state.site_data.carousel">
        <Slide v-for="item, i in $store.state.site_data.carousel" :key="i" :item="item" />
    </agile>
    <div v-if="$store.state.site_data.featured_categories && $store.state.site_data.featured_categories.length > 0" class="section featured-categories bg-white">
        <div class="container">
            <div class="columns">
                <div class="column" v-for="item, i in $store.state.site_data.featured_categories">
                    <fctile :item="item" :key="i" />
                </div>
            </div>
        </div>
    </div>
    <section class="section recommended bg-smoke">
        <div class="container">
            <div class="columns titles">
                <div class="column"><h2 class="title is-3">{{picked_title}}</h2></div>
                <div class="column is-narrow">
                    <template v-for="item, i in product_titles" v-if="product_titles">
                        <button :class="['recommended__title-button', {'is-active': picked_title == item}]" @click.prevent="picked_title = item">{{item}}</button><i class="seperator" v-if="i < product_titles.length -1"></i>
                    </template>
                </div>
            </div>
            <div v-if="picked_title == 'Featured Prodcuts'" class="featured-products columns is-variable is-5 is-multiline is-mobile">
                <ProductTile :class="'column is-' + col_size" v-for="item, i in featured.list" v-if="featured && featured.list.length > 0" :product="item" :key="i" />
                <div class="column is-12 has-text-centered is-action">
                    <router-link class="button is-primary" :to="featured.action">View More</router-link>
                </div>
            </div>
            <div v-if="picked_title == 'New Arrivals'" class="new-arrivals columns is-variable is-5 is-multiline is-mobile">
                <ProductTile :class="'column is-' + col_size" v-for="item, i in new_arrivals.list" v-if="new_arrivals && new_arrivals.list.length > 0" :product="item" :key="i" />
                <div class="column is-12 has-text-centered is-action">
                    <router-link class="button is-primary" :to="new_arrivals.action">View More</router-link>
                </div>
            </div>
            <div v-if="picked_title == 'Project & Fit-Out'" class="best-sellers columns is-variable is-5 is-multiline is-mobile">
                <ProductTile :class="'column is-' + col_size" v-for="item, i in best_sellers.list" v-if="best_sellers && best_sellers.list.length > 0" :product="item" :key="i" />
                <div class="column is-12 has-text-centered is-action">
                    <router-link class="button is-primary" :to="best_sellers.action">View More</router-link>
                </div>
            </div>
        </div>
    </section>
    <div class="section recommended categories" v-if="$store.state.site_data.promoted_categories && $store.state.site_data.promoted_categories.length > 0">
        <div class="container">
            <div class="columns promoted-categories">
                <div class="column" v-for="item, i in $store.state.site_data.promoted_categories">
                    <pctile :centred="i == 1" :item="item" :key="i" />
                </div>
            </div>
        </div>
    </div>
    <div class="section recommended brands" v-if="$store.state.site_data.brands && $store.state.site_data.brands.length > 0">
        <div class="container">
            <agile class="brands" :options="brand_aglie_opt">
                <div :class="'column slide is-' + col_size" v-for="item, i in $store.state.site_data.brands">
                    <router-link :to="{ path: $store.state.site_data.catalog_url, query: { brand: item.slug } }"><img :alt="item.title" :src="item.logo.url" /></router-link>
                </div>
            </agile>
        </div>
    </div>
    <section class="section recommended specials" v-if="$store.state.site_data.specials && $store.state.site_data.specials.list.length > 0">
        <div class="container">
            <div class="columns titles is-mobile">
                <div class="column"><h2 class="title is-3">Specials</h2></div>
                <div class="column is-narrow"><router-link class="button is-primary is-rounded is-small" :to="$store.state.site_data.specials.action">More</router-link></div>
            </div>
            <agile class="special-products" :options="aglie_opt">
                <ProductTile :class="'column slide is-' + col_size" v-for="item, i in $store.state.site_data.specials.list" :product="item" :key="i" />
            </agile>
        </div>
    </section>
    <div class="section bg-smoke">
        <div class="container">
            <PromoTile :item="$store.state.site_data.promo_tile" />
        </div>
    </div>
</main>
</template>

<script>
import { VueAgile } from 'vue-agile';
import Slide from '../blocks/elements/Slide';
import PromoTile from '../blocks/PromoTile';
import ProductTile from '../blocks/elements/ProductTile';
import FeaturedCategoryTile from '../blocks/elements/FeaturedCategoryTile';
import PromotedCategoryTile from '../blocks/elements/PromotedCategoryTile';
export default {
    name        :   'Homepage',
    components  :   {
        agile       :   VueAgile,
        Slide       :   Slide,
        PromoTile   :   PromoTile,
        ProductTile :   ProductTile,
        fctile      :   FeaturedCategoryTile,
        pctile      :   PromotedCategoryTile
    },
    data() {
        return {
            picked_title    :   null,
            picked_id       :   null,
            aglie_opt       : {
                slidesToShow: 2,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4
                        }
                    }
                ]
            },
            brand_aglie_opt       : {
                slidesToShow: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5
                        }
                    }
                ]
            }
        }
    },
    watch       :   {
        picked_title(nv, ov)
        {
            this.$nextTick().then(() => {
                $('.product-tile .title').matchHeight();
            });

            setTimeout(function () {
                $('.product-tile .title').matchHeight();
            }, 300);
        }
    },
    computed    :   {
        product_titles()
        {
            if (this.$store.state.site_data && this.$store.state.site_data.promoted_products) {
                return this.$store.state.site_data.promoted_products.map(o => o.title);
            }

            return null;
        },
        featured()
        {
            if (this.$store.state.site_data && this.$store.state.site_data.promoted_products) {
                return this.$store.state.site_data.promoted_products.find( o => o.title == 'Featured Prodcuts');
            }

            return null;
        },
        new_arrivals()
        {
            if (this.$store.state.site_data && this.$store.state.site_data.promoted_products) {
                return this.$store.state.site_data.promoted_products.find( o => o.title == 'New Arrivals');
            }

            return null;
        },
        best_sellers()
        {
            if (this.$store.state.site_data && this.$store.state.site_data.promoted_products) {
                return this.$store.state.site_data.promoted_products.find( o => o.title == 'Project & Fit-Out');
            }

            return null;
        },
        col_size()
        {
            if (this.$store.state.width <= 1024) {
                if (this.$store.state.width < 768) {
                    return 6;
                }
                return 4;
            }
            return 3;
        }
    },
    mounted()
    {
        this.$nextTick().then(() => {
            $(window).resize();
            $('.product-tile .title').matchHeight();
        });

        if (this.product_titles && this.product_titles.length) {
            this.picked_title   =   this.product_titles[0];
            this.picked_id      =   this.$store.state.site_data.promoted_products[0].id
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage.vue